import Swal from 'sweetalert2';

const DarkSwal = Swal.mixin({
  customClass: {
    popup: 'swal2-dark-popup',
    confirmButton: 'swal2-dark-confirm',
    cancelButton: 'swal2-dark-cancel',
  },
  background: 'rgba(30, 30, 47, 0.95)', 
  color: '#ffffff',
  confirmButtonColor: '#1344af',
  cancelButtonColor: '#6c757d',
});

export default DarkSwal;
